/**
 * PresenceBadge — online / in-game / away / offline dot (Phase C).
 *
 * Renders nothing for 'invisible' or 'offline' by default (a non-owner never
 * receives 'invisible' anyway — the server strips it). `in_game` carries the
 * room so a Phase-D join invite can be seeded.
 */

import type { ConnectionPresence, PresenceStatus } from '../../types/social';
import './PresenceBadge.css';

const LABEL: Record<PresenceStatus, string> = {
  online: 'Online',
  in_game: 'In game',
  away: 'Away',
  offline: 'Offline',
  invisible: 'Offline',
};

interface Props {
  presence?: ConnectionPresence;
  /** Show the text label next to the dot. */
  showLabel?: boolean;
}

export function PresenceBadge({ presence, showLabel = false }: Props) {
  const status: PresenceStatus = presence?.status ?? 'offline';
  // 'invisible' should never reach a viewer; treat it as offline defensively.
  const normalized: PresenceStatus = status === 'invisible' ? 'offline' : status;

  return (
    <span className={`presence-badge presence-badge--${normalized}`} title={LABEL[normalized]}>
      <span className="presence-badge__dot" aria-hidden />
      {showLabel && <span className="presence-badge__label">{LABEL[normalized]}</span>}
    </span>
  );
}

export default PresenceBadge;
